import { useQuery } from '@tanstack/react-query';
import { getP100QuoteDetails } from '../api';
import { getData } from '../../../../../utils/functional/fp';
import { resolveP100RaterVersionFromEntity } from '../utils';

type RaterVersionSourceEntity =
  | {
      quoteId?: string;
      boostRaterVersion?: string | null;
      productVersion?: number | null;
    }
  | null
  | undefined;

/** Policy → linked quote (`quoteId`) fallback for P100 V5/V6. */
export function useP100RaterVersionFallback(entity: RaterVersionSourceEntity) {
  const directVersion = resolveP100RaterVersionFromEntity(entity);
  const quoteId = entity?.quoteId;

  const linkedQuoteQuery = useQuery({
    queryKey: ['p100-quote-details', quoteId],
    queryFn: () => getP100QuoteDetails(quoteId as string).then(getData),
    enabled: directVersion == null && Boolean(quoteId),
  });

  return {
    version:
      directVersion ?? resolveP100RaterVersionFromEntity(linkedQuoteQuery.data),
    isLoading:
      directVersion == null && Boolean(quoteId) && linkedQuoteQuery.isLoading,
  };
}
